import "jquery";
import _ from "lodash";
import "./live.scss";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";
import page_template from "../../layouts/page-template";
import page_header from "../header/header";
import page_footer from "../footer/footer";
import coffee_main from "../coffee.main";
import youtube_icon_img from "../../assets/icons/youtube.png";

const page_template_content = document.getElementById(
  "js__page_template_content"
);
const page_template_header_title = document.getElementById(
  "js__page_template_header_title"
);
const base_url = coffee_main.base_url;
const id_season = coffee_main.id_season;
const page_title = "Juego en vivo";

//set page template and loader
page_template.setPageTemplate();

//size menu items on sidebar
page_header.setPageTemplate();

//content for page
//page title
coffee_main.createSectionTitle(page_title, page_template_header_title);

/**** main content start ****/
//live video
let title = document.createElement("h1");
title.innerText = "Sigue los partidos en vivo";
page_template_content.appendChild(title);
page_template_content.appendChild(document.createElement("br"));

let live_video_container = document.createElement("div");
live_video_container.classList.add("row");
showVideoLive(live_video_container);

page_template_content.appendChild(live_video_container);

//historico label
let title_historico = document.createElement("h1");
title_historico.innerText = "Historial de videos";
page_template_content.appendChild(document.createElement("br"));
page_template_content.appendChild(document.createElement("br"));
page_template_content.appendChild(title_historico);

//youtube chaner video label
let youtube_container = document.createElement("div");

let youtube_icon = document.createElement("img");
youtube_icon.src = youtube_icon_img;
youtube_container.appendChild(youtube_icon);

let youtube_text = document.createElement("span");
youtube_text.innerText = " /LNBPoficial";
youtube_container.appendChild(youtube_text);
page_template_content.appendChild(youtube_container);

//history video list
let videos_container = document.createElement("div");
page_template_content.appendChild(videos_container);

showVideos(videos_container);

/**** main content end ****/

//page_footer
page_footer.render(base_url, id_season);

//hide loader at the end, always at the bottom of this index file
$(window).on("load", function () {
  page_template.hideLoader();
});

//********* page functions start ******/
function createVideoCard(item, div_element) {
  let container = document.createElement("a");
  container.classList.add("col-sm-12", "col-md-4", "col-lg-4", "news_type_2");

  container.href = item.url;
  container.target = "_blank";

  let img = document.createElement("img");
  img.src = base_url + item.full_url_thumbnail;

  let title = document.createElement("span");
  title.innerHTML = item.name.slice(0, 30) + "...";
  title.classList.add("news_type_2_title");

  let line = document.createElement("hr");

  let description = document.createElement("span");
  description.innerHTML = item.description.slice(0, 60) + "...";

  let date = document.createElement("span");
  date.innerHTML = item.created_at.slice(0, 10);
  date.classList.add("news_type_2_date");

  container.appendChild(img);
  container.appendChild(title);
  container.appendChild(line);
  container.appendChild(description);
  container.appendChild(date);

  div_element.appendChild(container);
}
async function showVideos(container) {
  let row = document.createElement("div");
  row.classList.add("row");

  await getVideos().then((result) => {
    result.items.forEach((element) => {
      createVideoCard(element, row);
    });
  });

  container.appendChild(row);
}

function createVideoCardLarge(item, div_element) {
  let div_container = document.createElement("div");
  div_container.classList.add("live_video_container");
  let container = document.createElement("a");
  container.href = item.url_live;
  container.target = "_blank";
  container.classList.add("col-sm-12", "col-md-4", "col-lg-4");
  //div_element.classList.add('live_video_container');

  //live message
  let live_message_container = document.createElement("div");
  live_message_container.classList.add("col-sm-12", "col-md-12", "col-lg-12");

  let live_message = document.createElement("h3");

  if (item.url_live === "") {
    live_message.innerHTML =
      item.event.date_start +
      " <br>" +
      item.event.time_start.slice(0, 5) +
      " hrs";
    container.removeAttribute("href");
  } else {
    live_message.innerText = "¡Sigue el juego en vivo aquí!";
  }
  live_message_container.appendChild(live_message);

  //team 1 vs team 2
  let teams_container = document.createElement("div");
  teams_container.classList.add("col-sm-12", "col-md-12", "col-lg-12");

  // add styles
  live_message_container.style.paddingTop = "1rem";
  teams_container.style.paddingBottom = "1rem";

  let team_1 = document.createElement("img");
  team_1.style.width = "5rem";
  team_1.src = base_url + item.team_1.full_url_logo;

  let vs = document.createElement("span");
  vs.innerText = "VS";

  let team_2 = document.createElement("img");
  team_2.style.width = "5rem";
  team_2.src = base_url + item.team_2.full_url_logo;

  teams_container.appendChild(team_1);
  teams_container.appendChild(vs);
  teams_container.appendChild(team_2);

  div_container.appendChild(live_message_container);
  div_container.appendChild(teams_container);

  container.appendChild(div_container);

  div_element.appendChild(container);
}

async function showVideoLive(container) {
  await getVideoLive()
    .then((response) => {
      if (response.items.length >= 0) {
        response.items.forEach((item) => {
          createVideoCardLarge(item, container);
        });
      }

      return response;
    })
    .then((past_response) => {
      if (past_response.items.length <= 0)
        getVideoNextGames().then((response) => {
          if (response.items.length <= 0) {
            // call if there are no next games
            let description = document.createElement("p");
            description.innerText = "No hay videos en vivo por el momento.";
            container.classList.remove("live_video_container");
            container.appendChild(description);
          } else {
            // console.log("this is the response next live games", response);
            let event_day = response.items[0].event.date_start;
            response.items.forEach((item) => {
              if (item.event.date_start === event_day)
                createVideoCardLarge(item, container);
            });
          }
        });
    });
}
//ajax calls

async function getVideos() {
  //Prepare the request data.
  var ajax_data = {};

  return $.ajax({
    type: "POST",
    url: base_url + "/media/videos/all",
    data: ajax_data
  });
}

async function getVideoLive() {
  var ajax_data = {
    live: true
  };

  return $.ajax({
    type: "POST",
    url: base_url + "/sports/games/filtered",
    data: ajax_data
  });
}

async function getVideoNextGames() {
  var ajax_data = {
    next_games: true
  };

  return $.ajax({
    type: "POST",
    url: base_url + "/sports/games/filtered",
    data: ajax_data
  });
}
